<template>
    <div id="app">
        <header :class="{ live: getApiUser.user_name }">
            <router-link v-if="getApiUser.user_name && getApiUserType == 'SALES_REP'" :to="{ name: 'dlink', params: {} }"><img src="@/assets/nssncompasslogowhite.png" class="logo" /></router-link>
            <router-link v-else-if="getApiUser.user_name" :to="{ name: 'overview', params: {} }"><img src="@/assets/nssncompasslogowhite.png" class="logo" /></router-link>
            <div v-if="getApiUser.user_type_code" style="display: inline-block; vertical-align: super;">
                <font-awesome-icon icon="fa-chevron-right" /> {{ getApiUser.user_type_code }}
                <span v-if="getApiUser.source_code"> <font-awesome-icon icon="fa-chevron-right" /> {{ getApiUser.source_code }}</span>
            </div>
            <div v-if="getApiUser.user_name" class="hamburger"><font-awesome-icon icon="fa-bars" class="icon" @click="showNav = !showNav"/></div>
            <div v-if="getApiUser.user_name" class="identity">Welcome {{ getApiUser.user_name }}</div>
            <nav v-if="getApiUser.user_name" :class="{ live: showNav }">
                <div class="nav-inner">
                    <router-link v-if="getUserTypeAccess.dashboard.includes(getApiUserType)" :to="{ name: 'overview', params: {} }">Overview</router-link>
                    <router-link v-if="getUserTypeAccess.inventory.includes(getApiUserType)" :to="{ name: 'inventory', params: {} }">Store Inventory</router-link>
                    <router-link v-if="getUserTypeAccess.received.includes(getApiUserType)" :to="{ name: 'received', params: {} }">Inventory Received</router-link>
                    <router-link v-if="getUserTypeAccess.sales.includes(getApiUserType)" :to="{ name: 'sales', params: {} }">Store Sales</router-link>
                    <router-link v-if="getUserTypeAccess.warehouse.includes(getApiUserType)" :to="{ name: 'warehouse', params: {} }">Warehouse Orders</router-link>
                    <router-link v-if="getUserTypeAccess.distributors.includes(getApiUserType)" :to="{ name: 'distributors', params: {} }">Distributor Movement</router-link>
                    <router-link v-if="getUserTypeAccess.manufacturers.includes(getApiUserType)" :to="{ name: 'manufacturers', params: {} }">Manufacturers</router-link>

                    <div v-if="getIsDistributor || getIsAdministrator">
                        <div class="divider"></div>
                        <router-link :to="{ name: 'dlink', params: {} }">D-Link</router-link>
                    </div>
                    <div v-if="getIsAdministrator">
                        <div class="divider"></div>
                        <router-link :to="{ name: 'promo-packs', params: {} }">Promo Packs</router-link>
                    </div>
                    <div v-if="getIsAdministrator">
                        <div class="divider"></div>
                        <router-link :to="{ name: 'indexes', params: {} }">Industry Indexes</router-link>
                        <router-link :to="{ name: 'merge-products', params: {} }">Merge Products</router-link>
                        <router-link :to="{ name: 'merge-manufacturers', params: {} }">Merge Manufacturers</router-link>
                        <router-link :to="{ name: 'merge-suppliers', params: {} }">Merge Suppliers</router-link>
                        <router-link :to="{ name: 'merge-calibers', params: {} }">Merge Calibers</router-link>
                        <router-link :to="{ name: 'manage-clients', params: {} }">Manage Clients</router-link>
                    </div>
                    <div v-else-if="getApiUser.admin">
                        <div class="divider"></div>
                        <router-link :to="{ name: 'manage-clients', params: {} }">Manage Account</router-link>
                    </div>
                    <div class="divider"></div>
                    <router-link :to="{ name: 'contact', params: {} }">Contact & Support</router-link>
                    <router-link :to="{ name: 'profile', params: {} }">My Profile</router-link>
                    <router-link :to="{ name: 'login', query: { logout: 'do' } }">Log Out</router-link>
                </div>
            </nav>
        </header>
        <main id="main">
            <RouterView />
        </main>
        <footer>
            NSSN Compass 3.0 | Powered by the National Shooting Sports Network | &copy; {{ getThisYear() }} All Rights Reserved | <router-link :to="{ name: 'contact', params: {} }">Contact & Support</router-link>
        </footer>
    </div>
</template>
<script>
export default {
	name: 'app',
	data() {
        return {
            showNav: false
        }
    },
    mounted() {
        if (!this.getApiUser && sessionStorage.getItem('token') && sessionStorage.getItem('user')) {
            this.resetLoggedInUser()
        }
    },
    watch: {
        '$route' () {
            this.showNav = false
        }
    },
    methods: {
        userCanAccess(which) {
            if (!this.getApiUser && !this.getApiUser.user_type_code) {
                return false
            }
            let canAccess = false
            switch (which) {
            case 'inventory':
                canAccess = ['SUPERADMIN', 'ADMIN', 'DISTRIBUTOR'].includes(this.getApiUser.user_type_code)
                break;
            case 'received':
                canAccess = ['SUPERADMIN', 'ADMIN', 'DISTRIBUTOR'].includes(this.getApiUser.user_type_code)
                break;
            case 'sales':
                canAccess = ['SUPERADMIN', 'ADMIN', 'DISTRIBUTOR'].includes(this.getApiUser.user_type_code)
                break;
            case 'warehouse':
                canAccess = ['SUPERADMIN', 'ADMIN', 'DISTRIBUTOR'].includes(this.getApiUser.user_type_code)
                break;
            case 'distributors':
                canAccess = ['SUPERADMIN', 'ADMIN', 'DISTRIBUTOR'].includes(this.getApiUser.user_type_code)
                break;
            case 'manufacturers':
                canAccess = ['SUPERADMIN', 'ADMIN', 'DISTRIBUTOR'].includes(this.getApiUser.user_type_code)
                break;
            }
            return canAccess
        }
    }
}
</script>
